import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { EventsService, UtilService, VariablesService } from 'projects/roj/src/app/shared/services';
import { SharedModule } from 'projects/roj/src/app/shared/shared.module';

@Component({
  selector: 'app-fundraiser-card',
  standalone: true,
  imports: [CommonModule, MatButtonModule, SharedModule],
  templateUrl: './fundraiser-card.component.html',
  styleUrls: ['./fundraiser-card.component.scss']
})
export class FundraiserCardComponent {

  @Input() theme;
  @Input() fundraiser;
  @Input() eventInfo;
  @Input() openInNewTab;
  @Input() noRedirect;
  @Input() isExternal: boolean = false;
  
  currency = 'INR';
  supporterImages: string[];
  isFundraiserEnded;

  constructor(
    private events: EventsService,
    public util: UtilService,
    private vars: VariablesService
  ) { }
  userData;

  ngOnInit() {
    this.vars.userData.subscribe(val => {
      this.userData = val;
    });
    if (this.fundraiser) {
      this.isFundraiserEnded = this.util.checkFundraiserEnded(this.fundraiser?.status_flag, this.fundraiser?.end_date);
    }
  }

  goToFundraiser(e) {
    if (this.noRedirect) return;
    let eventName = 'click_on_fundraiser';
    const btnClasses = ['donate-btn', 'mat-button-wrapper', 'mat-button'];
    const targetClass = e?.target?.classList?.value || '';
    btnClasses.forEach(val => {
      if (targetClass.split(' ').includes(val)) {
        eventName = 'click_on_contribute';
      }
    });
    const donorNonDonor = this.userData?.aggdonationall?.funds > 0 ? 'donor': 'non_donor';
    this.events.sendSystemEvent({
      eventName: eventName,
      info_1: donorNonDonor || '',
      info_2: this.fundraiser?.id
    }).subscribe(_ => _);
    const redirectionRoutePrefix = '/stories/';
    if(this.isExternal && this.util.isBrowser){
      const message = `${window.location?.origin}${redirectionRoutePrefix}${this.fundraiser?.custom_tag}`;
      window.parent.postMessage(message, "*");
      return true;
    }
    else if (this.openInNewTab) {
      const donatePopup = eventName === 'click_on_contribute' ? '?donate=1' : '';
      this.util.nativeNavigation(`${redirectionRoutePrefix}${this.fundraiser?.custom_tag}${donatePopup}`, true);
    } else {
      this.util.router.navigate([redirectionRoutePrefix + this.fundraiser?.custom_tag], {
        queryParams: {
          donate: eventName === 'click_on_contribute' ? 1 : null,
          payment: 'form'
        }
      }).then(() => {
        this.util.scrollToTop('instant');
      });
    }
  }
}
